import React , { useEffect }from 'react';
import {useHistory} from "react-router-dom";
import classes from "../SensorDashboard.module.scss";
import GaugeComponent from 'react-gauge-component';
import { render } from 'react-dom'
import Thermometer from 'react-thermometer-component'

const toFahrenheit = (celsius) => (celsius * 9 / 5) + 32;

const getUnitSpecificGaugeConfig = (unit) => {
    const isCelsius = unit === 'C' || unit === '°C';

    const C_MAX_SCALE = 100;
    const C_MIN_SCALE = 0;

    // Determine target limits based on unit

    const UNIT_SUFFIX = isCelsius ? 'ºC' : 'ºF';

    return {
        MIN_SCALE: isCelsius ? C_MIN_SCALE : toFahrenheit(C_MIN_SCALE),
        MAX_SCALE: isCelsius ? C_MAX_SCALE : toFahrenheit(C_MAX_SCALE),
        UNIT_SUFFIX: UNIT_SUFFIX,

    };
};
const GrainSiloSensorInfoPanel = ({ sensor,onClose }) => {
    const history = useHistory();

    const handleGraphRedirectClick = (groupsId, sensorId) => {
        history.push(`/graphs/${groupsId}/${sensorId}`);
        return;
    }

       useEffect(() => {
        const style = document.createElement('style');
        style.type = 'text/css';

        // Define the CSS rules to remove the pseudo-elements (the bulb shadows/structure)
        const cssOverrides = `
            /* Targets the element that holds the bulb structure */
            .thermometer__draw-b:before, .thermometer__draw-b:after {
                background-color: #00FF00 !important;
            }
            
            .thermometer .thermometer__bg-color {
                background: linear-gradient(to top, #00FF00 0%, #FFFF00 25%, #FF0000 100%) !important
            }
        `;

        style.appendChild(document.createTextNode(cssOverrides));
        document.head.appendChild(style);

        // Cleanup: Remove the style tag when the component unmounts
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    if (!sensor) {
        return (

        <div className={classes.SensorWrap}>
            <div className={classes.sensorsGroupBlockTitle}>
              Click a sensor point on the 3D model to view its details.
            </div>
        </div>
        );
    }


    const unit = sensor.Meta?.Units || 'C';


    const gaugeConfig = getUnitSpecificGaugeConfig(unit);
    return (
        <div style={{
           display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',

            position: 'relative',
            padding: '5px',
            border: `2px solid ${sensor.Status === 'WARNING' ? '#CC0000' : '#4CAF50'}`,
            borderRadius: '8px',
            // Reduced bottom margin
            marginBottom: '5px',
            marginRight: '3px',
            backgroundColor: 'white',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)', // Subtler shadow

            maxWidth: '220px',
        }}>
            <button
                onClick={() => onClose(sensor.Id)}
                style={{
                    position: 'absolute',
                    top: -5,
                    right: -2,
                    background: 'none',
                    border: 'none',
                    color: '#CC0000',
                    fontSize: '28px',
                    cursor: 'pointer',
                    padding: '5px',
                    lineHeight: '1',
                    zIndex: 10,
                    transition: 'color 0.1s ease-in-out',
                }}
                title={`Close ${sensor.Name}`}
            >
                &times;
            </button>
            <p style={{
                margin: '5px 5px 2px 5px',
                fontSize: '14px',
                fontWeight: 'bold',
                color: sensor.Status === 'WARNING' ? '#CC0000' : '#444'
            }}>
                {sensor.Name}
            </p>
            <span style={{
                fontSize: '12px',
                marginBottom: '5px',
                color: sensor.Status === 'WARNING' ? '#CC0000' : '#4CAF50'
            }}>
                 Status: {sensor.Status}
            </span>
            <div style={{
                width: '100%',
                maxWidth: '200px',
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'center'
            }}>



                {/* Thermometer Gauge Placeholder */}
                <Thermometer
                    theme="light"
                    value={sensor.Value}
                    max={gaugeConfig.MAX_SCALE}
                    format={gaugeConfig.UNIT_SUFFIX}
                    size="normal"
                    height="130"
                />
            </div>
            <button
                onClick={() => handleGraphRedirectClick(sensor.group?.Id, sensor.Id)}
                style={{
                    marginTop: '8px',
                    marginBottom: '2px',
                    background: 'none',
                    border: '1px solid #4CAF50',
                    borderRadius: '4px',
                    color: '#4CAF50',
                    fontSize: '12px',
                    cursor: 'pointer',
                    padding: '4px 10px',
                    transition: 'background-color 0.1s ease-in-out',
                }}
                title={`View graph for ${sensor.Name}`}
            >
                View Graph
            </button>

        </div>
    );
};

export default GrainSiloSensorInfoPanel;